import './bootstrap';
import Vue from "vue";
import VueRouter from "vue-router";
import Notifications from 'vue-notification';
import changeCase from "vue-change-case";
import router from "./router";

Vue.use(VueRouter);
Vue.use(Notifications);
Vue.use(changeCase);

const app = new Vue({
	router
}).$mount('#app');

export default app;
